<template>
  <div class="slider">
    <!-- prettier-ignore -->
    <input
      type="radio"
      name="slider"
      title="slide"
      class="slider__nav"
      :checked="slide.id == 0"
      v-for="slide in slides"
      v-bind:key="slide.id"
    />
    <div class="slider__inner" :style="{ width: slideInnerWidth }">
      <!-- prettier-ignore -->
      <div class="slider__contents" v-for="slide in slides" v-bind:key="slide.id">
        <img
          class="slider__image"
          v-if="slide.image_l"
          v-bind:src="require('../assets/images/' + slide.image_l)"
        />
        <!-- prettier-ignore -->
        <div class="slider__quote" v-if="slide.quote">
          <i class="slider__icon" v-if="slide.quote.icon" v-bind:class="slide.quote.icon"></i>
          <h2 class="slider__caption" v-if="slide.quote.caption">{{ slide.quote.caption }}</h2>
          <p class="slider__txt">{{ slide.quote.text }}</p>
        </div>
        <!-- notes -->
        <textarea class="slider__note" v-if="slide.note" v-model="slide.note"></textarea>
        <!-- list -->
        <div class="slider__list" v-if="slide.list">
          <h2 class="slider__caption" v-if="slide.list.caption">{{ slide.list.caption }}</h2>
          <p class="slider__items" v-html="slide.list.html"></p>
        </div>
        <img
          class="slider__image"
          v-if="slide.image_r"
          v-bind:src="require('../assets/images/' + slide.image_r)"
        />
      </div>
    </div>
  </div>
</template>
<script>
import eventBus from "../eventBus";
export default {
  name: "Slider",
  data: function() {
    return {
      validToken: false,
      slideInnerWidth: "200%",
      slides: [
        {
          id: 0,
          quote: {
            icon: "fa fa-check",
            caption: "simplicity",
            text:
              "Simple can be harder than complex, it required a hardwork to get a clean thinking to make it simple."
          },
          image_r: "sample_design.png"
        },
        {
          id: 1,
          image_l: "sample_design.png",
          note: `Lorem ipsum dolor sit amet, senserit repudiare an sed, qui ad equidem deserunt.\n\nEos at admodum incorrupte. Ullum iisque argumentum quo an, usu nonumes scaevola te.\nSed in repudiandae definitiones, ei eum sale modus. In duo erat explicari,\n\nduo eu option accusamus. Eos ei omittam posidonium, aperiam reprimique qui ad.\n\nEa nibh harum vix, eu putent deterruisset ius. Facilisis mnesarchum incorrupte per ei.\n\nId oratio nonumy pro. Duo eu aliquid epicuri eloquentiam, dolore causae alienum id sea.\n\nNe mel nonumes ceteros molestiae, an consul salutatus sententiae eos.`
        }
      ]
    };
  },
  mounted() {
    eventBus.$on("SLIDE_UPDATED", contents => {
      this.onChangeSlide(contents);
    });
  },
  methods: {
    onChangeSlide: function(contents) {
      this.slideInnerWidth = contents.length * 100 + "%";
      this.slides.splice(contents.length);
      this.slides = contents.slice(0); //update array the correct way
    }
  }
};
</script>
<style scoped>
/*--- slider --*/
html,
body {
  height: 100%;
}
@import url(https://fonts.googleapis.com/css?family=Roboto:400);
@import url(https://use.fontawesome.com/releases/v5.10.2/css/all.css);
*,
*:before,
*:after {
  box-sizing: border-box;
}
.slider {
  height: 350px;
  position: relative;
  overflow: hidden;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-flow: row nowrap;
  -ms-flex-flow: row nowrap;
  flex-flow: row nowrap;
  -webkit-box-align: end;
  -webkit-align-items: flex-end;
  -ms-flex-align: end;
  align-items: flex-end;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;

  border-top: 3px dashed #ddd;
  border-bottom: 3px dashed #ddd;
  max-width: 1300px;
  margin-left: auto;
  margin-right: auto;
}
.slider__nav {
  width: 12px;
  height: 12px;
  margin: 1.5rem 12px;
  border-radius: 50%;
  z-index: 10;
  outline: 6px solid #ccc;
  outline-offset: -6px;
  box-shadow: 0 0 0 0 #333, 0 0 0 0 rgba(51, 51, 51, 0);
  cursor: pointer;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}
.slider__nav:checked {
  -webkit-animation: check 0.4s linear forwards;
  animation: check 0.4s linear forwards;
}
.slider__nav:checked:nth-of-type(1) ~ .slider__inner {
  left: 0%;
}
.slider__nav:checked:nth-of-type(2) ~ .slider__inner {
  left: -100%;
}
.slider__nav:checked:nth-of-type(3) ~ .slider__inner {
  left: -200%;
}
.slider__nav:checked:nth-of-type(4) ~ .slider__inner {
  left: -300%;
}
.slider__inner {
  position: absolute;
  top: 0;
  left: 0;
  width: 200%; /* 100% * number of slides */
  height: 100%;
  -webkit-transition: left 0.4s;
  transition: left 0.4s;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-flow: row nowrap;
  -ms-flex-flow: row nowrap;
  flex-flow: row nowrap;
}
.slider__contents {
  height: 100%;
  padding: 0rem;
  text-align: center;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
}
.slider__icon {
  font-size: 2.7rem;
  color: #2196f3;
}
.slider__caption {
  font-weight: 500;
  margin: 0.5rem 0 0.5rem;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
  text-transform: uppercase;
}
.slider__txt {
  color: #444;
  margin: 0.5rem 0 3rem;
  max-width: 300px;
  min-height: 2.5em;
  font-style: italic;
}
.slider__description {
  -webkit-flex-flow: column nowrap;
  -ms-flex-flow: column nowrap;
  flex-flow: column nowrap;
}
.slider__image {
  flex-grow: 0;
  flex-shrink: 0;
  margin: 0 0.5rem;
  height: 270px;
}
.slider__note {
  color: #444;
  margin: 0.5rem 0 3rem;
  width: 70%;
  height: 270px;
  list-style-type: square;
  resize: none;
  font-size: 1em;

  border: none;
  overflow: auto;
  outline: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
}

.slider__list {
  color: #444;
  margin: 0.5rem 0 3rem;
  width: 300px;
  height: 270px;
  list-style-type: square;
  resize: none;
  font-size: 1em;

  border: none;
  overflow: auto;
  outline: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
}
.slider__items {
  text-align: left;
  margin: 0;
  padding: 0;
}
.slider__items >>> ul {
  list-style-type: square;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;
  padding-left: 20px;
}

@-webkit-keyframes check {
  50% {
    outline-color: #333;
    box-shadow: 0 0 0 12px #333, 0 0 0 36px rgba(51, 51, 51, 0.2);
  }
  100% {
    outline-color: #333;
    box-shadow: 0 0 0 0 #333, 0 0 0 0 rgba(51, 51, 51, 0);
  }
}

@keyframes check {
  50% {
    outline-color: #333;
    box-shadow: 0 0 0 12px #333, 0 0 0 36px rgba(51, 51, 51, 0.2);
  }
  100% {
    outline-color: #333;
    box-shadow: 0 0 0 0 #333, 0 0 0 0 rgba(51, 51, 51, 0);
  }
}

@media screen and (min-width: 400px) {
  .slider__contents {
    width: auto;
  }
  .slider__image {
    display: none;
  }
}
@media screen and (min-width: 600px) {
  .slider__contents {
    width: 500px;
  }
  .slider__image {
    display: flex;
    height: 220px;
  }
}
@media screen and (min-width: 900px) {
  .slider__contents {
    width: auto;
  }
  .slider__image {
    display: flex;
    height: 250px;
  }
}
@media screen and (min-width: 1100px) {
  .slider__contents {
    width: auto;
  }
  .slider__image {
    display: flex;
    height: 250px;
  }
}

/*--- end slider --*/
</style>
